<template>
  <div>
    <v-card class="mt-2">
      <v-card-title class="headline">
        Upcoming Recommended Journey
      </v-card-title>
      <v-skeleton-loader v-if="$apollo.loading" type="card" />
      <div v-else class="pa-4 pt-0 mb-4 mr-4">
        <recommendation-timeline :userId="userId" @block-clicked="selectedBlockId = $event" class="mt-4" />
        <block-history :userId="userId" :allowCreate="true"></block-history>
      </div>
    </v-card>
  </div>
</template>

<script>
import RecommendationTimeline from "@/components/workout_blocks/RecommendationTimeline";
import BlockHistory from "@/components/workout_blocks/BlockHistory";

export default {
  name: "RecommendedJourney",
  components: {
    RecommendationTimeline,
    BlockHistory,
  },
  props: {
    userId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      selectedBlockId: null,
    };
  },
};
</script>
